import { createAction } from "@coverme/redux";
import Axios from "axios";

export const getCaseClues = encounterId => {
    return createAction("GET_CASECLUES", () => {
        return Axios.get(`api/encounter/${encounterId}/caseclues`)
            .then(data => data.data)
            .catch(err => {
                return {
                    error: "Case clues fetch failed.",
                };
            });
    });
};
